<div class="row">
  <div class="col-md-12">
    <table id="summaryTable" class="table table-sm table-striped table-bordered">
      <thead>
        <tr class="align-middle">
          <th rowspan="2"></th>
          <th rowspan="2">Date</th>
          <th rowspan="2">vessel Name</th>
          <th rowspan="2">CHAR.</th>
          <!-- <th rowspan="2">OPS</th> -->
          <th rowspan="2">Position</th>
          <th rowspan="2">FLG</th>
          <th rowspan="2">DEST.</th>
          <th rowspan="2">ETA</th>
          <th rowspan="2">B-L</th>
          <th colspan="2">ROB</th>
          <th colspan="2">Last Received Date</th>
          <th colspan="2">Last Received QTY</th>
          <th rowspan="2">BL Date</th>
          <!-- <th rowspan="2">Price</th> -->
          <th rowspan="2">Cargo</th>
          <th colspan="2">Speed</th>
          <th rowspan="2">Wind/Sea</th>
          <th colspan="2">Dry Dock</th>
        </tr>

        <tr>
          <th>LSFO</th>
          <th>LSMGO</th>
          <th>LSFO</th>
          <th>LSMGO</th>
          <th>LSFO</th>
          <th>LSMGO</th>
          <th>C/P</th>
          <th>Present</th>
          <th>Last</th>
          <th>Next</th>
        </tr>
      </thead>
      <tbody>
        @for (report of reports; track $index) {
          <tr [class.opacity-50]="checkUpdatedNoon(report.noonReportV2020)">
            <td>
              @if (report.noonReportV2020.fileId) {
                <a (click)="downloadFile(report.noonReportV2020)">
                  <i class="fa fa-file-excel" aria-hidden="true"></i>
                </a>
              }
            </td>
            <td>{{ formatDate(report.noonReportV2020.date.timestamp) }}</td>
            <td [class.text-green]="report.noonReportV2020.voyageDetails.isLaden">
              {{ capitalize(report.vessel.name.name) }}
            </td>
            <td>{{ organisationFormatter(report.voyage.charterer) }}</td>
            <td>{{ capitalize(report.noonReportV2020.position.currentLocation).substring(0, 20) }}</td>
            <td>{{ report.vessel.name.flag }}</td>
            <td>{{ capitalize(report.noonReportV2020.voyageDetails.destination) }}</td>
            <td [class.text-green]="checkEta(report.noonReportV2020)">
              {{ formatDate(report.noonReportV2020.voyageDetails.eta) }}
            </td>
            <td [class.text-green]="report.noonReportV2020.voyageDetails.isLaden">
              {{ report.noonReportV2020.voyageDetails.isLaden ? 'Laden' : 'Ballast' }}
            </td>
            <td>{{ robFormatter(report.noonReportV2020, 'fo') }}</td>
            <td>{{ robFormatter(report.noonReportV2020, 'lsmgo') }}</td>
            <td>{{ formatDate(bunkerLastRecievedDate(report.noonReportV2020, 'lsfo')) }}</td>
            <td>{{ formatDate(bunkerLastRecievedDate(report.noonReportV2020, 'lsmgo')) }}</td>
            <td>{{ bunkerLastRecievedFormatter(report.noonReportV2020, 'fo') }}</td>
            <td>{{ bunkerLastRecievedFormatter(report.noonReportV2020, 'lsmgo') }}</td>
            <td [class.text-green]="report.noonReportV2020.voyageDetails.isLaden">
              {{ blFormatter(report.voyage, report.noonReportV2020.voyageDetails.isLaden) }}
            </td>
            <td [class.text-green]="report.noonReportV2020.voyageDetails.isLaden">
              {{ formatCargoOnboard(report.noonReportV2020) }}
            </td>
            <td>
              {{ report.vessel.spec?.charterPartySpeed?.economicalLadenSpeed }}-{{ report.vessel.spec?.charterPartySpeed?.maximumBallastSpeed }}
            </td>
            <td>{{ speedFormatter(report.noonReportV2020.speed.averageSpeed) }}</td>
            <td>{{ windSeaFormatter(report.noonReportV2020) }}</td>
            <td>{{ report.vessel.spec?.dryDock?.lastDryDock }}</td>
            <td
              [class.text-red]="checkDryDockExpirey(report.vessel) === 0"
              [class.text-warning]="checkDryDockExpirey(report.vessel) === 1">
              {{ report.vessel.spec?.dryDock?.nextDryDock }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="col-md-12">
    <table id="bunkerTable" class="table table-sm table-striped table-bordered">
      <thead>
        <tr class="align-middle">
          <th rowspan="2">vessel Name</th>
          <th rowspan="2">P&I</th>
          <th rowspan="2">MGR</th>
          <th rowspan="2">Owner</th>
          <th rowspan="2">GRT</th>
          <th rowspan="2">DD</th>
          <th rowspan="2">Age</th>
          <th rowspan="2">Builder</th>
        </tr>
      </thead>
      <tbody>
        @for (report of reports; track $index) {
          <tr [ngClass]="{'opacity-50': checkUpdatedNoon(report.noonReportV2020)}">
            <td>{{ report.vessel.name.name }}</td>
            <td>{{ organisationFormatter(report.vessel.spec.ownershipOperationProtection.protectionIndemnityId) }}</td>
            <td>{{ organisationFormatter(report.vessel.spec.ownershipOperationProtection.managerId) }}</td>
            <td>{{ organisationFormatter(report.vessel.spec.ownershipOperationProtection.ownerId) }}</td>
            <td>{{ report.vessel.spec.dimensionsCapacities.grt | number }}</td>
            <td>{{ report.vessel.spec.yearBuilt }}</td>
            <td>{{ vesselAge(report.vessel) }}</td>
            <td>{{ organisationFormatter(report.vessel.spec.ownershipOperationProtection.builderId) }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
